import React from 'react'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { Button } from '@material-ui/core'
import { inviteBegun } from 'utils/mixpanel'
import { setNotification } from 'actions/status'
import { useDispatch } from 'react-redux'

export default function InviteButton(buttonProps) {
  const dispatch = useDispatch()
  const communityId = useCurrentUserProp('community')
  const shareableLink = window.location.origin + `/invite/${communityId}`

  function copyLink() {
    inviteBegun('Link')
    navigator.clipboard.writeText(shareableLink)
    dispatch(setNotification('success', 'Shareable invite link copied to clipboard'))
  }

  return (
    <Button { ...buttonProps } onClick={copyLink}>
      invite others
    </Button>
  )
}
